/* product-tabs セクション共通スクリプト
 * 旧: sections/product-tabs.liquid 内の <script> 3ブロック（View allのhref同期／
 * sticky offset更新／z-index同期）を統合し、さらに「非アクティブタブの遅延読み込み」を追加。
 *
 * - 同じセクションが何個置かれても、resize購読1本・ResizeObserver1本に集約
 * - 遅延読み込み: 非アクティブタブは空のプレースホルダで出力されており（Liquid側）、
 *   タブ切替(tabChange)時に Section Rendering API
 *   （/collections/<handle>?section_id=<id>）で該当タブの中身だけ取得して差し込む。
 *   マウスオーバー/フォーカスで先読みして体感を速くする。
 */
(function () {
  'use strict';
  if (window.__cdrProductTabsInit) return; // 同一scriptタグが複数あっても1回だけ
  window.__cdrProductTabsInit = true;

  var HEADER_SELECTOR =
    '[data-section-type="header"], .shopify-section-header, header.header, header.site-header, .section--header';

  var registered = []; // sticky変数を更新する対象セクション（root要素）

  function getHeader() {
    return document.querySelector(HEADER_SELECTOR);
  }

  function headerHeight(header) {
    return header ? Math.max(0, header.getBoundingClientRect().height) : 0;
  }

  function headerZ(header) {
    if (!header) return NaN;
    var n = parseInt(window.getComputedStyle(header).zIndex, 10);
    return isNaN(n) ? NaN : n;
  }

  function updateStickyVars() {
    var header = getHeader();
    var offset = headerHeight(header) + 'px';
    var hz = headerZ(header);
    var tz = String(!isNaN(hz) ? Math.max(hz - 1, 0) : 1); // タブはヘッダーの1段下
    registered.forEach(function (root) {
      root.style.setProperty('--tabs-sticky-offset', offset);
      root.style.setProperty('--tabs-sticky-z', tz);
    });
  }

  var observedHeader = null;
  var headerRO = null;
  function ensureHeaderObserved() {
    var header = getHeader();
    if (!header || header === observedHeader || !('ResizeObserver' in window)) return;
    if (headerRO) headerRO.disconnect();
    headerRO = new ResizeObserver(updateStickyVars);
    headerRO.observe(header);
    observedHeader = header;
  }

  /* ---- View all ボタンのhref同期（旧script 1本目） ---- */
  function initViewAll(root, sectionId) {
    var nav = root.querySelector('.tabs__nav');
    var topBtn = root.querySelector('#product-tabs-view-all-top-' + sectionId);
    var bottomBtn = root.querySelector('#product-tabs-view-all-bottom-' + sectionId);

    function setHref(url) {
      if (!url) return;
      if (topBtn) { topBtn.href = url; topBtn.removeAttribute('aria-disabled'); }
      if (bottomBtn) { bottomBtn.href = url; bottomBtn.removeAttribute('aria-disabled'); }
    }

    function initHref() {
      if (!nav) return;
      var active =
        nav.querySelector('.tabs__tab[aria-selected="true"][data-collection-url]') ||
        nav.querySelector('.tabs__tab.is-active[data-collection-url]') ||
        nav.querySelector('.tabs__tab[data-collection-url]');
      if (active) setHref(active.dataset.collectionUrl);
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('.tabs__tab[data-collection-url]');
        if (btn) setHref(btn.dataset.collectionUrl);
      });
      nav.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          var btn = e.target.closest('.tabs__tab[data-collection-url]');
          if (btn) setHref(btn.dataset.collectionUrl);
        }
      });
    }
    initHref();
  }

  /* ---- 非アクティブタブの遅延読み込み ---- */
  function initLazyTabs(root) {
    var productTabs = root.querySelector('product-tabs');
    if (!productTabs) return;

    var pending = {}; // panel.id -> fetch Promise

    function fetchPanel(panel) {
      var url = panel.dataset.tabUrl;
      if (!url) return null;
      if (!pending[panel.id]) {
        pending[panel.id] = fetch(url)
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var src = doc.getElementById(panel.id);
            var grid = src && src.querySelector('grid-list');
            if (!grid) throw new Error('panel not found in response');
            return grid;
          })
          .catch(function (err) {
            delete pending[panel.id]; // 失敗したら次のクリックで再試行できるように
            throw err;
          });
      }
      return pending[panel.id];
    }

    function insertContent(panel, grid) {
      if (panel.dataset.tabLoaded === 'true') return;
      var imported = document.importNode(grid, true);
      var placeholder = panel.querySelector('grid-list');
      if (placeholder) {
        placeholder.replaceWith(imported); // theme.jsがtemplateを展開済みの場合
      } else {
        var tpl = panel.querySelector('template');
        if (tpl) tpl.remove();
        panel.appendChild(imported); // 展開前に先読みが済んだ場合
      }
      panel.dataset.tabLoaded = 'true';
      panel.removeAttribute('aria-busy');
      if (typeof imported.showGridItems === 'function') {
        imported.showGridItems();
      }
    }

    function loadPanel(panel, visible) {
      if (!panel || panel.dataset.tabLoaded === 'true' || !panel.dataset.tabUrl) return;
      var job = fetchPanel(panel);
      if (!job) return;
      if (visible) panel.setAttribute('aria-busy', 'true');
      job
        .then(function (grid) { insertContent(panel, grid); })
        .catch(function () {
          panel.removeAttribute('aria-busy');
          // 取得に失敗しても手詰まりにしない: コレクションへのリンクを出す
          if (visible && !panel.querySelector('.products-list > *') && !panel.querySelector('.tabs__load-error')) {
            var url = panel.dataset.tabUrl.split('?')[0];
            var p = document.createElement('p');
            p.className = 'tabs__load-error';
            p.innerHTML = '<a href="' + url + '">View all</a>';
            panel.appendChild(p);
          }
        });
    }

    // タブ切替（theme.jsのTabsComponentがbubblesで投げる）
    productTabs.addEventListener('tabChange', function (e) {
      var panel = e.detail && e.detail.selectedTab;
      if (panel) loadPanel(panel, true);
    });

    // 先読み: タブボタンにポインタが乗った/フォーカスした時点で取得を始める
    var nav = root.querySelector('.tabs__nav');
    if (nav) {
      var prefetch = function (e) {
        var btn = e.target.closest('.tabs__tab');
        if (!btn || !btn.id) return;
        var panel = document.getElementById('tab-' + btn.id);
        if (panel && panel.dataset.tabUrl && panel.dataset.tabLoaded !== 'true') {
          fetchPanel(panel); // 取得だけ開始（挿入はtabChange時）
        }
      };
      nav.addEventListener('mouseover', prefetch);
      nav.addEventListener('focusin', prefetch);
      nav.addEventListener('touchstart', prefetch, { passive: true });
    }
  }

  /* ---- セクション初期化 ---- */
  function initSection(root) {
    if (!root || root.dataset.productTabsInit === 'true') return;
    root.dataset.productTabsInit = 'true';
    var sectionId = root.dataset.id;
    initViewAll(root, sectionId);
    initLazyTabs(root);
    if (registered.indexOf(root) === -1) registered.push(root);
  }

  function initAll() {
    document.querySelectorAll('.section--product-tabs[data-id]').forEach(initSection);
    // 取り外されたセクション（エディタ操作等）を掃除
    registered = registered.filter(function (root) { return document.contains(root); });
    ensureHeaderObserved();
    updateStickyVars();
  }

  window.addEventListener('resize', updateStickyVars);
  document.addEventListener('shopify:section:load', function () {
    initAll();
  });

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
})();
